import { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import BaseModel from 'volta/models/base-model';
import type SimulationItemSetting from 'volta/models/simulation-item-setting';
import type { ISimulationItemScenarioKPI } from 'volta/models/types/simulation';

export interface ISimulatedPlanningItem {
  key: string;
  inventoryDate: string;
  planning: ISimulationPlanningData;
}

export interface ISimulationPlanningData {
  demandQty: number;
  supplyQty: number;
  onHand: number;
  onHandSimulated: number;
  adu: number;
  reorderQty: number;
  receptionQty: number;
  bufferTOG: number;
  bufferTOY: number;
  bufferTOR: number;
  bufferGreen: number;
  bufferYellow: number;
  bufferRedBase: number;
  bufferRedSafety: number;
  netFlow: number;
  demandSpikeQty: number;
  daf: number;
  forecastQty: number;
  forecastQtyCleaned: number;
  forecastQtyNetFlow: number;
}

export const DataKeys: (keyof ISimulationPlanningData)[] = [
  'demandQty',
  'supplyQty',
  'onHand',
  'onHandSimulated',
  'adu',
  'reorderQty',
  'receptionQty',
  'bufferTOG',
  'bufferTOY',
  'bufferTOR',
  'bufferGreen',
  'bufferYellow',
  'bufferRedBase',
  'bufferRedSafety',
  'netFlow',
  'demandSpikeQty',
  'daf',
  'forecastQty',
  'forecastQtyCleaned',
  'forecastQtyNetFlow'
];

export default class SimulationItemPlanning extends BaseModel {
  @attr('string') itemSettingId!: string;
  @attr('string') simulationId!: string;
  @attr('string') scenarioId!: string;
  @attr('string') skuId!: string;
  @attr('array') inventoryDate!: string[];
  @attr('array') demandQty!: number[];
  @attr('array') supplyQty!: number[];
  @attr('array') onHand!: number[];
  @attr('array') onHandSimulated!: number[];
  @attr('array') adu!: number[];
  @attr('array') reorderQty!: number[];
  @attr('array') receptionQty!: number[];
  @attr('array') bufferTOG!: number[];
  @attr('array') bufferTOY!: number[];
  @attr('array') bufferTOR!: number[];
  @attr('array') bufferGreen!: number[];
  @attr('array') bufferYellow!: number[];
  @attr('array') bufferRedBase!: number[];
  @attr('array') bufferRedSafety!: number[];
  @attr('array') netFlow!: number[];
  @attr('array') demandSpikeQty!: number[];
  @attr('array') daf!: number[];
  @attr('array') forecastQty!: number[];
  @attr('array') forecastQtyCleaned!: number[];
  @attr('array') forecastQtyNetFlow!: number[];
  @attr() stats?: ISimulationItemScenarioKPI;

  // Relationships

  @belongsTo('simulation-item-setting', { async: false, inverse: 'planning' })
  itemSetting!: SimulationItemSetting;

  [Type] = 'simulation-item-planning' as const;
}
